import React from "react";
import { RenderMediaContent } from "src/components/RenderMediaContent";

// Placeholder video - replace with actual video when available
const recordButtonActivityVideo = "https://www.youtube.com/watch?v=kE0b-6CYPik";

export const RecordButtonActivity: React.FC = () => {
    return (
        <div className="flex flex-col gap-6 px-4">
            <section className="flex flex-col gap-3">
                <p>
                    This feature is a part of the Real Time Inspector (formerly Button Overview).
                    It allows you to record button activity and see exactly which buttons triggered and when,
                    with precise timestamps.
                </p>
                <p>
                    Perfect for tracking down rogue buttons triggering unexpectedly, or debugging complex deck setups.
                </p>
            </section>

            <section className="flex flex-col gap-4">
                <RenderMediaContent src={recordButtonActivityVideo} />
            </section>

            <section className="flex flex-col gap-3">
                <h3 className="text-lg font-semibold">How to Use</h3>
                <ol className="list-decimal space-y-2 pl-6">
                    <li>
                        Open the <b>Inspector</b> menu in Deck Hopper, and switch to the <b>Real Time Inspector</b> tab.
                    </li>
                    <li>
                        Click the <b>Record</b> button to start recording button activity.
                    </li>
                    <li>
                        Trigger buttons in your decks as normal.
                    </li>
                    <li>
                        All the buttons that are triggered will appear in the list below with their timestamps.
                    </li>
                </ol>
            </section>
        </div>
    );
};

export default RecordButtonActivity;
